import React, { createContext, useContext } from 'react';
import { useAppNotification } from '../../hooks/useAppNotification.jsx';

const AppNotificationContext = createContext(null);

export function AppNotificationProvider({ children }) {
  const { contextHolder, notify } = useAppNotification();

  return (
    <AppNotificationContext.Provider value={notify}>
      {contextHolder}
      {children}
    </AppNotificationContext.Provider>
  );
}

export function useNotify() {
  return useContext(AppNotificationContext);
}
